'use client'
import type { CSSProperties } from 'react'

import { FALLBACK_APP_URL } from '@morpho-org/dapp-core'
import { Button } from '@repo/ui'

import { ButtonLink } from '@/components/common/ButtonLink'
import { useSectionErrorBoundaryReset } from '@/components/common/SectionErrorBoundary'
import { clientEnvs } from '@/config/client-envs'

export interface ErrorServiceUnavailableProps {
  minHeight?: CSSProperties['height']
}

export default function ErrorServiceUnavailable({
  minHeight = '200px'
}: ErrorServiceUnavailableProps) {
  const resetSection = useSectionErrorBoundaryReset()

  return (
    <div
      className="gap-md p-md bg-card flex w-full flex-col items-center justify-center rounded-[20px]"
      style={{ minHeight }}
    >
      <div className="gap-sm flex flex-col">
        <span className="text-sm" style={{ textAlign: 'center' }}>
          Something went wrong.
        </span>
        <span
          className="text-2xs text-secondary-foreground"
          style={{ maxWidth: '450px', textAlign: 'center' }}
        >
          This could be due to connectivity or other local issues. Try refreshing the app or
          managing your positions through the Morpho Fallback App.
        </span>
      </div>
      <div className="gap-sm flex">
        {resetSection !== undefined && (
          <Button size="sm" onClick={resetSection}>
            Try again
          </Button>
        )}
        <ButtonLink
          mode="external"
          href={FALLBACK_APP_URL}
          buttonProps={{
            size: 'sm',
            label: 'Use Fallback App'
          }}
        />
        <ButtonLink
          mode="external"
          href={clientEnvs.NEXT_PUBLIC_STATUS_URL}
          buttonProps={{
            size: 'sm',
            variant: 'secondary',
            label: 'Check App Status'
          }}
        />
      </div>
    </div>
  )
}
